import { AppStoreButton } from '../app-store-button/app-store-button'
import styles from './app-nudge.module.css'

type AppNudgeProps = {
  title: string
  body?: string
  image?: React.ReactNode
}

export const AppNudge = ({ title, body, image }: AppNudgeProps) => (
  <div className={styles.container}>
    <div className={styles.contentContainer}>
      <div className={styles.text}>
        <h2 className={styles.title}>{title}</h2>
        {body && <p className={styles.subtitle}>{body}</p>}
      </div>
      <div className={styles.buttons}>
        <AppStoreButton store="apple-store" />
        <AppStoreButton store="google-play" />
      </div>
    </div>
    {image && <div className={styles.imageContainer}>{image}</div>}
  </div>
)
